import { BuildedMessage } from "@/protocols/messages"
import { Snooze } from "@/protocols/snooze"

import ApiService from "@/services/Api"

type RetrieveSnoozeResponse = {
	snooze: Snooze
}

type SnoozeContent = {
	messages?: BuildedMessage[]
}

export type SnoozeType = "message" | "waba-message-template" | "default"

export type CreateSnoozeRequest = {
	inboxChannelChatId: number
	content?: SnoozeContent
	wabaTemplateMessage?: {
		id: number
	}
	snoozeType: SnoozeType
}

type CreateSnoozeResponse = {
	snooze: {
		id: number
	}
}

type CancelSnoozeRequest = {
	userId: number
	scheduleId: number
}

class SnoozeService {
	async retrieveSnoozeById (snoozeId: number) : Promise<Snooze> {
		const response = await ApiService.get<RetrieveSnoozeResponse>(`/snoozes/${snoozeId}`)

		return response.data.snooze
	}

	async createSnooze (input: CreateSnoozeRequest): Promise<Pick<Snooze, "id">> {
		const response = await ApiService.post<CreateSnoozeResponse>("/snoozes", input)

		return response.data.snooze
	}

	async cancelSnooze (input: CancelSnoozeRequest) {
		await ApiService.post("/inbox/channel/chat/snooze/cancel", {
			payload: input
		})
	}
}

export default new SnoozeService()
